import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConstants {
    public GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/';
}